import { FormattedMessage } from 'react-intl';

import messages from 'src/components/rovo-dev-agents/src/i18n/requirements-not-met.i18n';

export const convertToBoolean = (
  value: string | boolean | undefined | null,
  fallbackValue: boolean = false
): boolean => {
  switch (typeof value) {
    case 'string':
      switch (value.toLowerCase()) {
        case 'true':
          return true;
        case 'false':
          return false;
        default:
          return fallbackValue;
      }
    case 'boolean':
      return value;
    default:
      return fallbackValue;
  }
};

export const getContent = (
  isWorkspacePaid: boolean,
  hasConnectedJiraSite: boolean,
  hasEnabledRovoDevAgents: boolean
): [FormattedMessage.MessageDescriptor, FormattedMessage.MessageDescriptor] => {
  // Create a string from the boolean values for easier comparison
  const condition = `${isWorkspacePaid}-${hasConnectedJiraSite}-${hasEnabledRovoDevAgents}`;
  switch (condition) {
    case 'false-false-false':
      return [messages.generalHeading, messages.youNeedAllThree];
    case 'true-false-false':
      return [messages.generalHeading, messages.youNeedRDAAndJira];
    case 'false-true-false':
      return [messages.generalHeading, messages.youNeedPaidAndRDA];
    case 'false-false-true':
      return [messages.generalHeading, messages.youNeedPaidAndJira];
    case 'false-true-true':
      return [messages.youNeedPaidHeading, messages.youNeedPaid];
    case 'true-true-false':
      return [messages.youNeedRDAHeading, messages.youNeedRDA];
    case 'true-false-true':
      return [messages.youNeedJiraHeading, messages.youNeedJira];
    default: // this shouldn't happen
      return [messages.generalHeading, messages.youNeedAllThree];
  }
};
